import { digObject, sortArrayBy, toggleArray } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import type { UserModel } from '@models/types'

type Entity = {
  id: number,
  type: 'User' | 'Agency',
}

export type UseManageEntitySupportTeamPayload = {
  callbacks: {
    toggleSupportUserId: Function,
  },
  entityParams: {
    data: {
      support_team: {
        user_ids: number[],
      },
    },
  },
  hasSelectedSupportUsers: boolean,
  selectedSupportUserIds: number[],
  sortedSupportUsers: UserModel[],
  updating: boolean,
}

const toggleSupportUserId = (id: number | undefined, selectedSupportUserIds: [], setState: Function) => {
  if (!id) return

  const updatedSupportUserIds = toggleArray(selectedSupportUserIds, id)
  setState({ selectedSupportUserIds: updatedSupportUserIds })
}

const useManageEntitySupportTeamModal = (entity: Entity) => {
  // entity can be a User or Agency. User IDs are stored at 'data.support_team.user_ids'
  const supportUserIds = digObject(entity, 'data.support_team.user_ids', [])

  const [state, setState] = useSetState({ selectedSupportUserIds: supportUserIds })
  const { selectedSupportUserIds } = state

  const users = useSelector(reduxState => reduxState.entities.users)
  const updatingAgency = useSelector(reduxState => reduxState.agencies.updating)
  const updatingUser = useSelector(reduxState => reduxState.users.updating)

  const selectedSupportUsers = selectedSupportUserIds
    // @ts-expect-error TS7006
    .map(id => users[id])
    // @ts-expect-error TS7006
    .filter(u => u)

  const sortedSupportUsers = sortArrayBy(selectedSupportUsers, 'asc', 'first_name')

  const hasSelectedSupportUsers = !!selectedSupportUsers.length

  const entityParams = {
    data: {
      support_team: {
        user_ids: selectedSupportUserIds,
      },
    },
  }

  return {
    callbacks: {
      toggleSupportUserId: (id?: number) => toggleSupportUserId(id, selectedSupportUserIds, setState),
    },
    entityParams,
    hasSelectedSupportUsers,
    selectedSupportUserIds,
    sortedSupportUsers,
    updating: updatingAgency || updatingUser,
  }
}

export default useManageEntitySupportTeamModal
